<template>
  <div style="background-color: #eff6fc; height: 100%">
    <v-dialog v-model="loading_download" persistent width="300">
      <v-card color="#4EBCA6" dark class="pt-1">
        <v-card-text class="text-center">
          <div class="pt-2 white--text font-16">
            {{ text_loading }}
          </div>
          <v-progress-linear indeterminate color="white" class="mb-0"></v-progress-linear>
        </v-card-text>
      </v-card>
    </v-dialog>
    <!-- <v-app-bar app color="#FFFFFF" class="justify-center" elevate-on-scroll>
      <v-row>
        <v-col cols="2" class="px-3 pb-0 pt-0 ma-0" align="left">
          <v-btn icon small @click="back()"><v-icon style="color: #333333;">mdi-arrow-left</v-icon></v-btn>
        </v-col>
      </v-row>
    </v-app-bar> -->

    <v-content class="pt-0">
      <v-container fluid class="pa">
        <v-row class="justify-center pt-2">
          <span style="color: #203c59; font-size: 18px">ผลตรวจสุขภาพ</span>
        </v-row>

        <!-- การ์ดรายงานผลตรวจสุขภาพ -->
        <v-row class="justify-center pt-5">
          <v-card outlined
            :style="type == 'line_oa' ? 'width: 90%; border-radius: 10px; border-color: #32b1ee' : 'width: 90%; border-radius: 10px; border-color: #4db7ad'"
            class="text-center">
            <v-card-text>
              <div>
                <img src="@/assets/img/bro.svg" />
              </div>
              <div>
                <span
                  style="font-size: 10px; color: #000000">กรุณาเลือกรายงานผลตรวจสุขภาพเพื่อระบุเอกสารที่ท่านต้องการ</span>
              </div>
              <div class="pt-1">
                <v-btn elevation="0" :color="type == 'line_oa' ? '#32b1ee' : '#00A99D'"
                  style="width: 80%; border-radius: 10px" @click="showChoice">
                  <span class="white--text" style="font-size: 12px">รายงานผลตรวจสุขภาพ</span>
                </v-btn>
              </div>
            </v-card-text>
          </v-card>
        </v-row>
        <!-- การ์ดรายงานผลตรวจสุขภาพ -->

        <!-- การ์ดใบรับรอง -->
        <v-row class="justify-center pt-5">
          <v-card outlined
            :style="type == 'line_oa' ? 'width: 90%; border-radius: 10px; border-color: #32b1ee' : 'width: 90%; border-radius: 10px; border-color: #4db7ad'"
            class="text-center" v-if="myChoice">
            <v-card-text>
              <div style="color: #000000; font-size: 14px">
                <span>กรุณาเลือกรายงานผลตรวจสุขภาพเพื่อระบุ</span>
              </div>
              <div style="color: #000000; font-size: 14px">
                <span>เอกสารที่ท่านต้องการ Download</span>
              </div>
              <div class="pt-3">
                <v-menu>
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn :color="type == 'line_oa' ? '#32b1ee' : '#00A99D'" elevation="0" dark v-bind="attrs"
                      v-on="on" @click="getYear()" :loading="loading_health_check"
                      style="width: 80%; border-radius: 10px">
                      <span class="white--text" style="font-size: 12px">
                        รายงานผลตรวจสุขภาพประจำปี
                      </span>
                      <v-icon right dark> mdi-chevron-down </v-icon>
                    </v-btn>
                  </template>
                  <div v-for="(item, index) in yearList" :key="index">
                    <v-btn v-if="item != 'รายงานผลตรวจสุขภาพประจำปี'" elevation="0" class="text-center btn-radius"
                      :color="'#EDFFF8'"
                      :style="type == 'line_oa' ? 'width: 100%; border: solid 1px #32b1ee' : 'width: 100%; border: solid 1px #00a99d'"
                      @click="downloadDoc('รายงานผลตรวจสุขภาพประจำปี', item)"><span :class="'text-list'"
                        style="font-size: 12px">
                        {{ item }}</span></v-btn>
                    <v-btn v-else elevation="0" class="text-center btn-radius"
                      :color="type == 'line_oa' ? '#32b1ee' : '#00A99D'"
                      :style="type == 'line_oa' ? 'width: 100%; border: solid 1px #32b1ee' : 'width: 100%; border: solid 1px #00a99d'"><span
                        :class="'white--text'" style="font-size: 12px">
                        {{ item }}</span></v-btn>
                  </div>
                </v-menu>
              </div>
              <div class="pt-3" v-show="true">
                <v-btn elevation="0" :color="type == 'line_oa' ? '#32b1ee' : '#00A99D'" class="btn-radius"
                  @click="downloadsummaryDoc()" style="width: 80%" :loading="loading_health_check">
                  <span class="white--text" style="font-size: 12px">สรุปผลตรวจสุขภาพ</span>
                </v-btn>
              </div>
              <div class="pt-3 list-btn">
                <v-menu>
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn color="#F40000" elevation="0" dark v-bind="attrs" v-on="on" class="btn-radius"
                      style="width: 80%" @click="getdocCert()">
                      <span class="white--text" style="font-size: 12px">
                        ใบรับรองอื่น
                      </span>
                      <v-icon right dark> mdi-chevron-down </v-icon>
                    </v-btn>
                  </template>
                  <div v-for="(item, index) in certList" :key="index">
                    <v-btn v-if="item != 'ใบรับรองอื่น ๆ'" elevation="0" class="text-center btn-radius"
                      :color="'#EDFFF8'"
                      :style="type == 'line_oa' ? 'width: 100%; border: solid 1px #32b1ee' : 'width: 100%; border: solid 1px #00a99d'"
                      @click="downloadDoc(item)"><span :class="'text-list'" style="font-size: 12px">
                        {{ item }}</span></v-btn>
                    <v-btn v-else elevation="0" class="text-center btn-radius"
                      :color="type == 'line_oa' ? '#32b1ee' : '#00A99D'"
                      :style="type == 'line_oa' ? 'width: 100%; border: solid 1px #32b1ee' : 'width: 100%; border: solid 1px #00a99d'"><span
                        :class="'white--text'" style="font-size: 12px">
                        {{ item }}</span></v-btn>
                  </div>
                </v-menu>
              </div>
            </v-card-text>
          </v-card>
        </v-row>
        <!-- การ์ดใบรับรอง -->
      </v-container>
      <View_PDF ref="viewPDF" />
    </v-content>
  </div>
</template>

<script>
import moment from "moment";
import View_PDF from "../../../components/dialog/ViewPDF.vue";
import get_access_token from "@/services/get_access_token";

export default {
  components: {
    View_PDF,
  },
  data() {
    return {
      share_token: this.$route.query.share_token,
      business_id: this.$route.query.business_id,
      yearList: ["รายงานผลตรวจสุขภาพประจำปี"],
      year: "รายงานผลตรวจสุขภาพประจำปี",
      myChoice: false,
      certList: ["ใบรับรองอื่น ๆ"],
      flatform: "",
      loading_document_health: false,
      loading_health_check: false,
      loading_download: false,
      text_loading: "",
      type: this.$route.query.type || "oneplatform",
      documentId: "",
      fileId:"",
      filterYear: "",
      typeDoc: ""
    };
  },
  async mounted() {
    if (
      !sessionStorage.access_token ||
      sessionStorage.access_token == "null"
    ) {
      sessionStorage.access_token = await get_access_token(this.share_token);
    }
    await this.checkConsent();
    console.log(navigator.userAgent);
    // Check if the user is using an Android device
    const isAndroid = /Android/i.test(navigator.userAgent);

    // Check if the user is using an iOS device
    const isiOS = /iPhone|iPad|iPod/i.test(navigator.userAgent);

    if (isAndroid) {
      console.log("User is using an Android device");
      this.flatform = "Android";
      // Perform Android-specific actions or UI changes
    } else if (isiOS) {
      console.log("User is using an iOS device");
      this.flatform = "iOS";

      // Perform iOS-specific actions or UI changes
    } else {
      console.log("User is using a device other than Android or iOS");
      this.flatform = "web";

      // Perform actions for other devices
    }
  },
  methods: {
    async checkConsent() {
      try {
        const params = new URLSearchParams();
        params.append("share_token", this.share_token);
        await this.axios
          .get(process.env.VUE_APP_BACKEND_URL + `/consent/v1/check?${params}`)
          .then(async (res) => {
            // console.log("res", res);
            if (res.data.result == "success" && res.data.data === true) {
              console.log("Consent Sucess");
            } else if (
              res.data.result == "success" &&
              res.data.data === false
            ) {
              this.$router.push(
                `/management/noti?business_id=${this.business_id}&share_token=${this.share_token}`
              );
            } else {
              this.$swal({
                type: "error",
                width: "auto",
                icon: "error",
                backdrop: false,
                showConfirmButton: false,
                timer: 1000,
              });
            }
          });
      } catch (error) {
        console.log("🚀 ~ error:", error);
        this.$swal({
          type: "error",
          title: "ระบบมีปัญหา",
          text: "กรุณาลองใหม่อีกครั้งค่ะ",
          width: "auto",
          icon: "error",
          allowOutsideClick: () => {
            const popup = this.$swal.getPopup();
            popup.classList.remove("swal2-show");
            setTimeout(() => {
              popup.classList.add("shake-sweetalert");
            });
            setTimeout(() => {
              popup.classList.remove("shake-sweetalert");
            }, 500);
            return false;
          },
          confirmButtonText: "OK",
          confirmButtonColor: "#00A99D",
        }).then((result) => {
          if (result.isConfirmed) {
            window.location.reload();
          }
        });
      }
    },
    back() {
      this.$router.go(-1);
    },
    showChoice() {
      this.myChoice = !this.myChoice;
    },
    ownloadFile(base64String, fileName) {
      // Base64 string representing the file
      // const base64String = "Your base64 string here";

      // Decode the base64 string
      const byteCharacters = atob(base64String);

      // Convert the byte characters to byte array
      const byteNumbers = new Array(byteCharacters.length);
      for (let i = 0; i < byteCharacters.length; i++) {
        byteNumbers[i] = byteCharacters.charCodeAt(i);
      }
      const byteArray = new Uint8Array(byteNumbers);

      // Create a Blob object from the byte array
      const blob = new Blob([byteArray], { type: "application/octet-stream" });

      // Generate a URL for the blob
      const url = URL.createObjectURL(blob);

      // Create a link element
      const link = document.createElement("a");
      link.href = url;
      link.download = `${fileName}.pdf`; // Set the desired file name

      // Simulate a click on the link to trigger the download
      link.click();

      // Clean up the URL object
      URL.revokeObjectURL(url);
    },
    async downloadDoc(way, year = "") {
      this.filterYear = parseInt(year - 543)
      await this.getdocByYear()
      console.log(this.flatform);
      this.loading_download = true;
      this.text_loading = "กำลังดาวน์โหลดเอกสาร";
      const array_cer = ["ใบรับรองอื่น ๆ", "ใบรับรองแพทย์สำหรับทำใบขับขี่"];
      try {
        if (!array_cer.includes(way)) {
          let params = new URLSearchParams();
          if (way == "ใบรับรองแพทย์") {
            params.append("doc_code", "MEDICAL_CERTIFICATE");
          } else if (way == "รายงานผลตรวจสุขภาพประจำปี") {
            this.loading_document_health = true;
            params.append("doc_code", "HEALTH_CHECK");
          } else if (
            way == "ใบรับรองแพทย์ การตรวจสุขภาพคนต่างด้าว/แรงงานต่างด้าว"
          ) {
            this.loading_document_health = true;
            params.append("doc_code", "FORMFOREINGWORKERS");
          } else if (way == "ใบอนุญาตขับขี่") {
            this.loading_document_health = true;
            params.append("doc_code", "DRIVING_LICENSE");
          } else if (way == "ใบสั่งจ่ายสมุนไพรควบคุม (กัญชา)") {
            this.loading_document_health = true;
            params.append("doc_code", "CONTROLLED_HERBS");
          } else if (way == "ใบสั่งยา") {
            this.loading_document_health = true;
            params.append("doc_code", "PRESCRIPTION_CERT");
          } else if (way == "ใบรับรองการตรวจรักษา") {
            this.loading_document_health = true;
            params.append("doc_code", "COMMENT_CERT");
          }
          params.append("one_access_token", this.share_token);
          params.append("biz_id", this.business_id);
          params.append("year", year == "" ? "" : parseInt(year - 543));
          params.append("platform", this.flatform || "");
          this.loading_download = false;
          const url = `${process.env.VUE_APP_BACKEND_URL}/mini_app/v1/sign/viewpdf?${params}`;
          this.typeDoc = "health_check"
          this.$refs.viewPDF.openDialog(url, this.type, this.documentId, this.fileId, this.typeDoc, this.share_token);
        }
      } catch (error) {
        console.error();
      }
    },
    async getYear() {
      try {
        const params = new URLSearchParams();
        params.append("one_access_token", this.share_token);
        params.append("biz_id", this.business_id);
        await this.axios
          .get(
            `${process.env.VUE_APP_BACKEND_URL}/main/v1/healthCheckyear?${params}`
          )
          .then((res) => {
            if (res.data.result == "success" && res.status == 200) {
                res.data.data.forEach((element) => {     
                const value_push = moment(element.checkDate)
                  .add(543, "year")
                  .format("YYYY");           
                  if (!this.yearList.includes(value_push)) {
                  this.yearList.push(value_push);
                }
              });
            } else {
              this.$swal({
                icon: "error",
                title:
                  "<span style='color: black;font-size: 20px;font-family: Sarabun, sans-serif;'>ไม่พบข้อมูลในระบบ</span>",
                confirmButtonText: "ปิด",
                confirmButtonColor: "#3085d6",
                showConfirmButton: false,
                timer: 3000,
              });
            }
          });
      } catch (error) {
        console.error();
        this.$swal({
          icon: "error",
          title:
            "<span style='color: black;font-size: 20px;font-family: Sarabun, sans-serif;'>ไม่พบข้อมูลในระบบ</span>",
          confirmButtonText: "ปิด",
          confirmButtonColor: "#3085d6",
          showConfirmButton: false,
          timer: 3000,
        });
      }
    },
    async getdocByYear() {
      try {
        const params = new URLSearchParams();
        params.append("one_access_token", this.share_token);
        params.append("biz_id", this.business_id);
        params.append("year", this.filterYear);
        await this.axios
          .get(
            `${process.env.VUE_APP_BACKEND_URL}/main/v1/healthCheckByYear?${params}`
          )
          .then((res) => {
            if (res.data.result == "success" && res.status == 200) {
              this.documentId = res.data.data._id
              this.fileId = res.data.data.file_id
              console.log("🚀 ~ getdocByYear ~ this.fileId:", this.fileId)
            } else {
              this.$swal({
                icon: "error",
                title:
                  "<span style='color: black;font-size: 20px;font-family: Sarabun, sans-serif;'>ไม่พบข้อมูลในระบบ</span>",
                confirmButtonText: "ปิด",
                confirmButtonColor: "#3085d6",
                showConfirmButton: false,
                timer: 3000,
              });
            }
          });
      } catch (error) {
        console.error();
        this.$swal({
          icon: "error",
          title:
            "<span style='color: black;font-size: 20px;font-family: Sarabun, sans-serif;'>ไม่พบข้อมูลในระบบ</span>",
          confirmButtonText: "ปิด",
          confirmButtonColor: "#3085d6",
          showConfirmButton: false,
          timer: 3000,
        });
      }
    },
    async downloadsummaryDoc() {
      try {
        this.loading_health_check = true;
        let params = new URLSearchParams();
        let params_check = new URLSearchParams();
        params.append("one_access_token", this.share_token);
        params.append("biz_id", this.business_id);
        params_check.append("one_access_token", this.share_token);
        params_check.append("biz_id", this.business_id);
        params_check.append("doc_code", "HEALTH_CHECK");
        await this.axios
          .get(
            `${process.env.VUE_APP_BACKEND_URL}/main/v1/sign/checkSummary?${params_check}`
          )
          .then((res) => {
            if (res.data.result == "success" && res.status == 200) {
              this.loading_health_check = false;
              const url = `${process.env.VUE_APP_BACKEND_URL}/mini_app/v1/sign/createpdf_summary?${params}`;
              this.typeDoc = "health_check_results"
              this.$refs.viewPDF.openDialog(url, this.type, this.documentId, this.fileId, this.typeDoc, this.share_token );
            } else {
              this.loading_health_check = false;
              this.$swal({
                icon: "error",
                title:
                  "<span style='color: black;font-size: 20px;font-family: Sarabun, sans-serif;'>ไม่พบข้อมูลในระบบ</span>",
                confirmButtonText: "ปิด",
                confirmButtonColor: "#3085d6",
                showConfirmButton: false,
                timer: 3000,
              });
            }
          });
        // ========================================================================================
        // const url = `${process.env.VUE_APP_BACKEND_URL}/v1/sign/createpdf_summary?${params}`;
        // this.$refs.viewPDF.openDialog(url)
        // console.log("url", url);
        // =========================================================================================
      } catch (error) {
        this.loading_health_check = false;
        console.error();
      }
    },
    async getdocCert() {
      try {
        const params = new URLSearchParams();
        params.append("one_access_token", this.share_token);
        params.append("biz_id", this.business_id);
        await this.axios
          .get(
            `${process.env.VUE_APP_BACKEND_URL}/main/v1/getDocumentUser?${params}`
          )
          // .get(`http://localhost:5000/v1/getDocumentUser?${params}`)
          .then((res) => {
            if (res.data.result == "success" && res.status == 200) {
              res.data.data.forEach((element) => {
                if (!this.certList.includes(element.doc_name)) {
                  this.certList.push(element.doc_name);
                }
              });
            } else {
              this.$swal({
                icon: "error",
                title:
                  "<span style='color: black;font-size: 20px;font-family: Sarabun, sans-serif;'>ไม่พบข้อมูลในระบบ</span>",
                confirmButtonText: "ปิด",
                confirmButtonColor: "#3085d6",
                showConfirmButton: false,
                timer: 3000,
              });
            }
          });
      } catch (error) {
        console.error();
        this.$swal({
          icon: "error",
          title:
            "<span style='color: black;font-size: 20px;font-family: Sarabun, sans-serif;'>ไม่พบข้อมูลในระบบ</span>",
          confirmButtonText: "ปิด",
          confirmButtonColor: "#3085d6",
          showConfirmButton: false,
          timer: 3000,
        });
      }
    },
  },
};
</script>

<style scoped>
.btn-radius {
  border-radius: 8px;
}

.text-list {
  color: #00a99d;
}

.v-menu__content {
  box-shadow: none;
}
</style>
